import axios from '../axios'

// モジュールに「外部サイトリンク」を項目として追加（レッスン＋外部リンク教材＋項目をまとめて作成）
const postModuleExternalLinkApi = async (moduleId, payload) => {
  return await axios.post(`api/lms/modules/${moduleId}/external-link`, payload)
}

export default postModuleExternalLinkApi
